
/**
  ブランクページ（初期表示用）
*/
<template>
  <v-ons-page>
    <div class="content">
      <div class="page_container">
      <div class="link_block"  @click="sendAlcoholCheck('2')" id="no">
          <ons-ripple ></ons-ripple>
      </div>
      <div class="link_block"  @click="sendAlcoholCheck('1')" id="yes">
          <ons-ripple ></ons-ripple>
      </div>
        <img class="bg_img" src="../assets/img/start_bg.jpg" alt="">
      </div>
    </div>
    
  </v-ons-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'blank',
  data() {
    return {}
  },
  created: function() {
    if(this.alc_token!=''){
      this.moveNextPage()
    }
  },
  computed: {
    ...mapGetters([
      'alc_token',
      'ShopCode',
      'ShopIP',
      'ApiVersion',
      'PortNo',
      'SlipNo',
      'SlipDate',
      'LinePageEnabled',
      'RepeaterSetting',
      ]),
  },
  methods: {
    ...mapActions([
      'SendAlcoholCheck',
      'navigatePage',
      'navigateWPPage',
      'setSessionToken',
      'setAlcToken',
    ]),
    moveNextPage(){
      const self=this
      
      if(self.RepeaterSetting){
          if(self.RepeaterSetting.repeater_page_enable=='1'){
            self.setAlcToken()
            self.navigatePage('repeater_answer') //新規リピーターページへ
          }else{
            if(self.LinePageEnabled=='true'){
              self.setAlcToken()
              self.navigatePage('line_friend') //LINEお友達登録ページへ遷移
            }else{
               self.setAlcToken()
              self.setSessionToken()
              self.navigateWPPage('menu_top')
            }
          }
        }
    },
    sendAlcoholCheck(answer){
      const self=this
      this.SendAlcoholCheck(answer)
      .then(()=>{
        self.moveNextPage()
      }).catch(error=>{
        //アルコールチェック失敗
        self.moveNextPage()
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";
/*
.content.start{
    padding: 20% 10% 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: url(../assets/img/home_bg.jpg) no-repeat!important;
    background-size: cover!important; 
    background-position: center;
    color: $base-font-color;
  }
  */
.content{
    padding: 0;
  }
.logo{
  margin-bottom: 30px;
}
.notice{
  text-align: center;
  margin-bottom: 20px;
}
.button_block{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn_alcohol_check{
  font-size: 14px;
  width: 48%;
  overflow: visible;
  margin: 5px;
  text-align: center;
  color: $base-font-color;
  border-color: $base-font-color;
}

#no{
  top: calc(100vw*510/750);
  left: calc(100vw*40/750);
  width: calc(100vw*670/750);
  height: calc(100vw*240/750);
}
#yes{
  top: calc(100vw*810/750);
  left: calc(100vw*40/750);
  width: calc(100vw*670/750);
  height: calc(100vw*240/750);
}

/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/StartPage.vue